(function () {
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '₱' + (Number(cents || 0) / 100).toLocaleString('en-PH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function moneyMarkup(cents, moneyFormat, additionalClass) {
    var classes = ['money'];

    if (additionalClass) {
      classes.push(additionalClass);
    }

    return '<span class="' + classes.join(' ') + '">' +
      escapeHtml(formatMoney(cents, moneyFormat)) +
    '</span>';
  }

  function refreshCurrencyConverter(shopCurrency) {
    var delays = [0, 250, 750, 1500, 3000];

    function convertPrices() {
      if (!window.Currency || typeof window.Currency.convertAll !== 'function') {
        return;
      }

      var selectedCurrency = '';

      try {
        if (window.Currency.cookie && typeof window.Currency.cookie.read === 'function') {
          selectedCurrency = window.Currency.cookie.read() || '';
        }
      } catch (error) {}

      if (!selectedCurrency && window.Currency.currentCurrency) {
        selectedCurrency = window.Currency.currentCurrency;
      }

      selectedCurrency = String(selectedCurrency || shopCurrency).toUpperCase();

      var priceElements = document.querySelectorAll('.rr-team-products__grid span.money');

      Array.prototype.forEach.call(priceElements, function (element) {
        var sourceAttribute = 'data-currency-' + shopCurrency.toLowerCase();

        if (!element.hasAttribute(sourceAttribute)) {
          element.setAttribute(sourceAttribute, element.innerHTML);
        }
      });

      if (selectedCurrency !== shopCurrency) {
        window.Currency.convertAll(
          shopCurrency,
          selectedCurrency,
          '.rr-team-products__grid span.money'
        );
      }
    }

    delays.forEach(function (delay) {
      window.setTimeout(convertPrices, delay);
    });

    document.dispatchEvent(new CustomEvent('rr:team-store-prices-rendered'));
  }

  function productCard(product, moneyFormat) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var available = product.available !== false;
    var price = moneyMarkup(product.price, moneyFormat, 'rr-team-product-card__current-price');
    var compareAt = product.compare_at_price && product.compare_at_price > product.price
      ? moneyMarkup(product.compare_at_price, moneyFormat, 'rr-team-product-card__compare')
      : '';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var url = root + 'products/' + encodeURIComponent(product.handle);

    return '<article class="rr-team-product-card">' +
      '<a class="rr-team-product-card__link" href="' + url + '">' +
        '<div class="rr-team-product-card__image-wrap">' +
          (image ? '<img class="rr-team-product-card__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<div class="rr-team-product-card__image-placeholder"></div>') +
          (!available ? '<span class="rr-team-product-card__badge">Sold out</span>' : '') +
        '</div>' +
        '<div class="rr-team-product-card__body">' +
          '<h3>' + escapeHtml(product.title) + '</h3>' +
          '<p class="rr-team-product-card__price">' + compareAt + price + '</p>' +
          '<span class="rr-team-product-card__button">' + (available ? 'View apparel' : 'View details') + '</span>' +
        '</div>' +
      '</a>' +
    '</article>';
  }

  function initCatalog(root) {
    var teamId = root.getAttribute('data-team-id');
    var endpoint = root.getAttribute('data-verification-endpoint');
    var teamName = root.getAttribute('data-team-name') || 'Team Store';
    var sessionHours = Number(root.getAttribute('data-session-hours') || 8);
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var shopCurrency = root.getAttribute('data-shop-currency') || 'PHP';
    var form = root.querySelector('[data-team-password-form]');
    var input = root.querySelector('[data-team-password-input]');
    var passwordToggle = root.querySelector('[data-team-password-toggle]');
    var submit = root.querySelector('[data-team-password-submit]');
    var message = root.querySelector('[data-team-password-message]');
    var gate = root.querySelector('[data-team-gate]');
    var products = root.querySelector('[data-team-products]');
    var grid = root.querySelector('[data-team-products-grid]');
    var empty = root.querySelector('[data-team-products-empty]');
    var lock = root.querySelector('[data-team-lock-store]');
    var storageKey = 'rr-team-store:' + teamId;
    var failures = 0;

    if (!teamId || !form) return;

    function showMessage(text) {
      message.textContent = text;
      message.hidden = false;
    }

    function clearMessage() {
      message.textContent = '';
      message.hidden = true;
    }

    function setLoading(loading) {
      submit.disabled = loading;
      submit.textContent = loading ? 'Checking…' : 'Enter store';
      input.disabled = loading;
    }

    function reveal() {
      gate.hidden = true;
      products.hidden = false;
    }

    function fetchProduct(handle) {
      var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      return fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      });
    }

    function loadProducts(handles) {
      reveal();
      grid.innerHTML = '<div class="rr-team-products__loading">Loading team apparel…</div>';

      return Promise.all((handles || []).map(function (handle) {
        return fetchProduct(handle).catch(function () { return null; });
      })).then(function (items) {
        items = items.filter(Boolean);
        grid.innerHTML = items.map(function (item) {
          return productCard(item, moneyFormat);
        }).join('');
        empty.hidden = items.length !== 0;

        if (items.length) {
          refreshCurrencyConverter(shopCurrency);
        }
      });
    }

    function saveSession(handles) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          expiresAt: Date.now() + sessionHours * 60 * 60 * 1000,
          products: handles
        }));
      } catch (error) {}
    }

    function restoreSession() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (saved && saved.expiresAt > Date.now() && Array.isArray(saved.products)) {
          loadProducts(saved.products);
          return true;
        }
        sessionStorage.removeItem(storageKey);
      } catch (error) {}
      return false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage();

      if (!endpoint) {
        showMessage('This team store is not connected yet. Please contact R&R Sports Apparel.');
        return;
      }
      if (!input.value) {
        showMessage('Enter your team password.');
        input.focus();
        return;
      }
      if (failures >= 5) {
        showMessage('Too many incorrect attempts. Please wait a few minutes and try again.');
        return;
      }

      setLoading(true);
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ team: teamId, password: input.value })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || !data.ok) {
            var error = new Error(data.message || 'Incorrect password. Please try again.');
            error.status = response.status;
            throw error;
          }
          return data;
        });
      }).then(function (data) {
        failures = 0;
        input.value = '';
        saveSession(data.products || []);
        return loadProducts(data.products || []);
      }).catch(function (error) {
        failures += 1;
        showMessage(error.status === 429 ? 'Too many attempts. Please wait and try again.' : error.message);
      }).then(function () {
        setLoading(false);
      });
    });
    if (passwordToggle) {
  passwordToggle.addEventListener('click', function () {
    var showPassword = input.type === 'password';

    input.type = showPassword ? 'text' : 'password';
    passwordToggle.setAttribute(
      'aria-pressed',
      showPassword ? 'true' : 'false'
    );
    passwordToggle.setAttribute(
      'aria-label',
      showPassword ? 'Hide password' : 'Show password'
    );

    input.focus();
  });
}

    if (lock) {
      lock.addEventListener('click', function () {
        try { sessionStorage.removeItem(storageKey); } catch (error) {}
        products.hidden = true;
        gate.hidden = false;
        input.focus();
      });
    }

    if (!restoreSession()) input.focus();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-team-catalog]');
    if (root) initCatalog(root);
  });
})();
